import { fetchDependencies } from './fetch-dependencies.mts'
import { outputDependencies } from './output-dependencies.mts'

import type { OutputKind } from '../../types.mts'

export async function handleDependencies({
  limit,
  offset,
  outputKind
}: {
  limit: number
  offset: number
  outputKind: OutputKind
}): Promise<void> {
  const result = await fetchDependencies({ limit, offset })

  await outputDependencies(result, { limit, offset, outputKind })
}
